import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));

document.write(
  `<h1 id="title">There and back again - a visualisation of the 2018 NZ census commuter data</h1>
   <a href="https://github.com/neon-ninja/TABA">
    <img 
      style="position: absolute; top: 0; right: 0; border: 0;" 
      src="https://s3.amazonaws.com/github/ribbons/forkme_right_gray_6d6d6d.png" 
      alt="Fork me on GitHub">
   </a>
 `
);
